export default function maskCoin(value?: string): string {
    if (value) {
        value = value.toString().replace('.', '').replace(',', '').replace(/\D/g, '')
        const options = { minimumFractionDigits: 2 }
        const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(value) / 100)

        return result
    }
    return ''
}

export function maskCoinRawData(value?: string | number): string {
    if (value) {
        const raw = value.toString()
        const options = { minimumFractionDigits: 2 }
        const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(raw))

        return result
    }
    return ''
}
